import { Price } from "../../../currency/price";
import {SeatsRowGroupType} from "./seats-row-group-type.enum";
import {SeatsRowModel} from "./seats-row.model";
import {ISeatsRowsGroupViewModel} from "./seats-rows-group-view-model.interface";

export class SeatsRowsGroupModel implements ISeatsRowsGroupViewModel {
    constructor(public readonly groupType: SeatsRowGroupType,
                private readonly _getDescription: () => string) {
    }

    readonly rows: SeatsRowModel[] = [];

    public get description(): string {
        return this._getDescription();
    }
    public get minPrice(): Price {
        return Price.min(this.rows.map(r => r.minPrice));
    }
}
